import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../../user.service';
import { USER_TTL_ES } from '../../../user.interface';
import { Subscription } from 'rxjs';
import { BranchStoreService } from '../../../../branch-stores/branch-store.service';
import { ROLES } from 'src/app/auth/interfaces/role.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';

@Component({
  selector: 'pg-user-create',
  templateUrl: './user-create.component.html'
})
export class UserCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  roles = ROLES;
  branchStores$: Subscription;
  allBranchStores = [];

  constructor(
    private fb: FormBuilder,
    private serviceBase: UserService,
    private branchStoreService: BranchStoreService
  ) {
    super(USER_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.fg = this.fb.group({
      names: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      surnames: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      username: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      roleId: [1, [Validators.required]]
    });

    this.branchStores$ = this.branchStoreService
      .getData$()
      .subscribe((data) => {
        this.allBranchStores = data;
      });
  }

  onSubmit() {
    this.createItem$(this.fg.value);
  }

  ngOnDestroy() {
    this.branchStores$.unsubscribe();
  }
}
